module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('md-card', {
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title pf-title"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Personal Details")])]), _vm._v(" "), _c('md-card-content', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-3 col-xl-3"
  }, [(this.imageHave) ? _c('div', {
    staticClass: "image-uploder-empty"
  }, [_c('img', {
    staticClass: "good-image",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/rcp_other/profile/' + this.profileDetails.profile_image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-icon",
    on: {
      "click": function($event) {
        return _vm.changeImage()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add_box")])])]) : _vm._e(), _vm._v(" "), (!this.imageHave) ? _c('div', {
    staticClass: "settings-page"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('croppa', {
    attrs: {
      "quality": 1,
      "width": 220,
      "height": 220,
      "placeholder": "Click here to upload your Profile",
      "placeholder-color": "#5b5b5b",
      "canvas-color": "transparent",
      "placeholder-font-size": 12,
      "show-remove-button": true,
      "accept": ".jpeg, .png, .jpg",
      "file-size-limit": 10240000,
      "prevent-white-space": true,
      "zoom-speed": 6,
      "initial-size": "cover",
      "initial-position": "center",
      "disable-drag-and-drop": false
    },
    on: {
      "file-type-mismatch": _vm.onFileTypeMismatch,
      "file-size-exceed": _vm.onFileSizeExceed,
      "mousemove": function($event) {
        _vm.profileIMG = _vm.croppa1.generateDataUrl()
      },
      "touchmove": function($event) {
        _vm.profileIMG = _vm.croppa1.generateDataUrl()
      }
    },
    model: {
      value: (_vm.croppa1),
      callback: function($$v) {
        _vm.croppa1 = $$v
      },
      expression: "croppa1"
    }
  }), _vm._v(" "), (_vm.profileIMG) ? _c('div', [(!_vm.editComplete.img) ? _c('div', {
    staticClass: "pro_upload-icon",
    on: {
      "click": function($event) {
        return _vm.uploadNow(_vm.profileIMG)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")])]) : _vm._e()]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('sync-loader', {
    attrs: {
      "loading": _vm.loading,
      "color": _vm.editModalColor
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-lg-9 col-xl-9"
  }, [_c('form', {
    staticClass: "row-rm-padding"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "email",
      "id": "email",
      "readonly": ""
    },
    model: {
      value: (_vm.profileDetails.email),
      callback: function($$v) {
        _vm.$set(_vm.profileDetails, "email", $$v)
      },
      expression: "profileDetails.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Organization")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "email",
      "id": "email",
      "readonly": ""
    },
    model: {
      value: (_vm.profileDetails.organization_name),
      callback: function($$v) {
        _vm.$set(_vm.profileDetails, "organization_name", $$v)
      },
      expression: "profileDetails.organization_name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('md-field', {
    class: _vm.getValidationClassProfileDetails('title')
  }, [_c('md-select', {
    attrs: {
      "name": "title",
      "id": "title",
      "placeholder": "Title*"
    },
    model: {
      value: (_vm.profileDetails.title),
      callback: function($$v) {
        _vm.$set(_vm.profileDetails, "title", $$v)
      },
      expression: "profileDetails.title"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "Mr."
    }
  }, [_vm._v("Mr")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Mrs."
    }
  }, [_vm._v("Mrs")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Mrs."
    }
  }, [_vm._v("Miss")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Mrs."
    }
  }, [_vm._v("Other")])], 1), _vm._v(" "), (!_vm.$v.profileDetails.title.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The title is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.profileDetails.title.required && this.profileDetailsBackendValidation.title.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.profileDetailsBackendValidation.title.errorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('md-field', {
    class: _vm.getValidationClassProfileDetails('first_name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "first_name",
      "id": "first_name"
    },
    model: {
      value: (_vm.profileDetails.first_name),
      callback: function($$v) {
        _vm.$set(_vm.profileDetails, "first_name", $$v)
      },
      expression: "profileDetails.first_name"
    }
  }), _vm._v(" "), (!_vm.$v.profileDetails.first_name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The First Name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.profileDetails.first_name.required && this.profileDetailsBackendValidation.first_name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.profileDetailsBackendValidation.first_name.errorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('md-field', {
    class: _vm.getValidationClassProfileDetails('last_name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "last_name",
      "id": "last_name"
    },
    model: {
      value: (_vm.profileDetails.last_name),
      callback: function($$v) {
        _vm.$set(_vm.profileDetails, "last_name", $$v)
      },
      expression: "profileDetails.last_name"
    }
  }), _vm._v(" "), (!_vm.$v.profileDetails.last_name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Last Name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.profileDetails.last_name.required && this.profileDetailsBackendValidation.last_name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.profileDetailsBackendValidation.last_name.errorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-field', {
    class: _vm.getValidationClassProfileDetails('phone_no')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "phone_no",
      "id": "phone_no"
    },
    model: {
      value: (_vm.profileDetails.phone_no),
      callback: function($$v) {
        _vm.$set(_vm.profileDetails, "phone_no", $$v)
      },
      expression: "profileDetails.phone_no"
    }
  }), _vm._v(" "), (!_vm.$v.profileDetails.phone_no.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Phone Number is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.profileDetails.phone_no.required && this.profileDetailsBackendValidation.phone_no.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.profileDetailsBackendValidation.phone_no.errorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-field', {
    class: _vm.getValidationClassProfileDetails('state_id')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("State")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "state_id",
      "id": "state_id"
    },
    model: {
      value: (_vm.profileDetails.state_id),
      callback: function($$v) {
        _vm.$set(_vm.profileDetails, "state_id", $$v)
      },
      expression: "profileDetails.state_id"
    }
  }, _vm._l((_vm.CountryList), function(item) {
    return _c('md-optgroup', {
      key: item.id,
      attrs: {
        "label": item.name
      }
    }, _vm._l((item.states), function(item2) {
      return _c('md-option', {
        key: item2.id,
        attrs: {
          "value": item.id + ',' + item2.id
        }
      }, [_vm._v(_vm._s(item2.name))])
    }), 1)
  }), 1), _vm._v(" "), (!_vm.$v.profileDetails.state_id.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The state_name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.profileDetails.state_id.required && this.profileDetailsBackendValidation.state_id.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.profileDetailsBackendValidation.state_id.errorMsg))]) : _vm._e()], 1)], 1)])])])])])])])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "btn primary-btn-my md-raised md-primary",
    on: {
      "click": _vm.validateSubmissionProfileDetails
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('md-card', {
    staticStyle: {
      "border-radius": "5px",
      "margin-top": "30px"
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title pf-title"
  }, [_c('i', {
    staticClass: "fa fa-bell",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Notification Settings")])]), _vm._v(" "), _c('md-card-content', [_c('form', {
    staticClass: "row-rm-padding"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('p', {
    staticClass: "notify-titlee"
  }, [_vm._v("Push Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('md-checkbox', {
    staticClass: "notifi-check",
    model: {
      value: (_vm.notifications.product_notifi),
      callback: function($$v) {
        _vm.$set(_vm.notifications, "product_notifi", $$v)
      },
      expression: "notifications.product_notifi"
    }
  }, [_vm._v("Product Notification\n                          "), _c('p', {
    staticStyle: {
      "color": "#8c8c8c"
    }
  }, [_vm._v("Get notified when new products are added on to the platform")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('md-checkbox', {
    staticClass: "notifi-check",
    model: {
      value: (_vm.notifications.document_notifi),
      callback: function($$v) {
        _vm.$set(_vm.notifications, "document_notifi", $$v)
      },
      expression: "notifications.document_notifi"
    }
  }, [_vm._v("Documents Notification\n                          "), _c('p', {
    staticStyle: {
      "color": "#8c8c8c"
    }
  }, [_vm._v("Get notified when new documents are added on to the platform")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('md-checkbox', {
    staticClass: "notifi-check",
    model: {
      value: (_vm.notifications.video_notifi),
      callback: function($$v) {
        _vm.$set(_vm.notifications, "video_notifi", $$v)
      },
      expression: "notifications.video_notifi"
    }
  }, [_vm._v("Video Notification\n                          "), _c('p', {
    staticStyle: {
      "color": "#8c8c8c"
    }
  }, [_vm._v("Get notified when new videos are added on to the platform")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "notify-titlee"
  }, [_vm._v("Email Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('md-checkbox', {
    staticClass: "notifi-check",
    model: {
      value: (_vm.notifications.product_email),
      callback: function($$v) {
        _vm.$set(_vm.notifications, "product_email", $$v)
      },
      expression: "notifications.product_email"
    }
  }, [_vm._v("Product Email Notification\n                        "), _c('p', {
    staticStyle: {
      "color": "#8c8c8c"
    }
  }, [_vm._v("Get notified via email when new products are added on to the platform")])])], 1)])])])])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "btn primary-btn-my md-raised md-primary",
    on: {
      "click": _vm.updateNotifications
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('md-card', {
    staticStyle: {
      "border-radius": "5px",
      "margin-top": "30px"
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title pf-title"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Change Password")])]), _vm._v(" "), _c('md-card-content', [_c('form', {
    staticClass: "row-rm-padding"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClassPassChange('scu_password')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Current password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "name": "scu_password",
      "id": "scu_password"
    },
    model: {
      value: (_vm.securityDetails.password),
      callback: function($$v) {
        _vm.$set(_vm.securityDetails, "password", $$v)
      },
      expression: "securityDetails.password"
    }
  }), _vm._v(" "), (!_vm.$v.securityDetails.password.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The your old password is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.securityDetails.password.required && this.securityDetailsBackendValidation.password.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.securityDetailsBackendValidation.password.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClassPassChange('new_password')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("New password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "name": "new_password",
      "id": "new_password"
    },
    model: {
      value: (_vm.securityDetails.new_password),
      callback: function($$v) {
        _vm.$set(_vm.securityDetails, "new_password", $$v)
      },
      expression: "securityDetails.new_password"
    }
  }), _vm._v(" "), (!_vm.$v.securityDetails.new_password.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The new Password is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.securityDetails.new_password.required && this.securityDetailsBackendValidation.new_password.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.securityDetailsBackendValidation.new_password.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClassPassChange('confirm_password')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "name": "confirm_password",
      "id": "confirm_password"
    },
    model: {
      value: (_vm.securityDetails.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.securityDetails, "confirm_password", $$v)
      },
      expression: "securityDetails.confirm_password"
    }
  }), _vm._v(" "), (!_vm.$v.securityDetails.confirm_password.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The confirm password is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.securityDetails.confirm_password.required && this.securityDetailsBackendValidation.confirm_password.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.securityDetailsBackendValidation.confirm_password.errorMsg))]) : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "btn primary-btn-my md-raised md-primary",
    on: {
      "click": _vm.validateSubmissionChngPForm
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-522aa275"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/UserProfileView.vue
// module id = 2092
// module chunks = 1